import { render } from "./ObservationPatient.vue?vue&type=template&id=f806adf4"
import script from "./ObservationPatient.vue?vue&type=script&lang=js"
export * from "./ObservationPatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__